import httpClient from '../../utilities/http/http-client';

const endPoint = '/v1/general/master-data';

export default {
  getDestinationType(params = {}) {
    return httpClient.post(endPoint + '/destination', params);
  },
  getDistrict(params = {}) {
    return httpClient.post(endPoint + '/district', params);
  },
  getLabel(params = {}) {
    return httpClient.post(endPoint + '/label', params);
  },
  saveLabel(params = {}) {
    return httpClient.post(endPoint + '/label/create', params);
  },
};
